import { Component } from '@angular/core';
import { Params } from '@angular/router';
import { ContactUsModalComponent } from 'src/app/shared/components/_modals/contact-us-modal/contact-us-modal.component';
import { AlertSeverity } from 'src/app/shared/enums/alert-severity.enum';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NotificationsService } from 'src/app/shared/services/notifications.service';

@Component({
  selector: 'app-alert-bar',
  templateUrl: './alert-bar.component.html',
  styleUrls: ['./alert-bar.component.scss'],
  standalone: false,
})
export class AlertBarComponent {
  readonly AlertSeverity = AlertSeverity;

  constructor(
    public notificationService: NotificationsService,
    private modalService: ModalService,
    private navigationService: NavigationService,
  ) {
  }

  openContactSupportModal(): void {
    this.modalService.open(ContactUsModalComponent);
  }

  async navigateByRoute(route: string[], queryParams?: Params): Promise<void> {
    await this.navigationService.navigateByRoute(route || [''], queryParams);
  }
}
